import React, { useEffect, useState } from "react";
import "./AllProducts.css";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AllProductsHero from "../../components/pages/AllProducts/AllProductsHero/AllProductsHero";
import AllProductsExplore from "../../components/pages/AllProducts/AllProductsExplore/AllProductsExplore";
import Hospitality from "../../components/pages/Home/Hospitality/Hospitality";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import { getPageContent } from "../../api/content";
import { useTranslation } from "react-i18next";
import {
  findPageSection,
  getAboutStartNewProjectContent,
  unwrapSectionData,
} from "../../utils/aboutStartNewProjectSection";

const AllProducts = () => {
  const { i18n } = useTranslation();
  const [pageContent, setPageContent] = useState({});
  const [aboutContent, setAboutContent] = useState({});

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const language = (i18n.language || "en").toLowerCase();
      const pageAliases = ["allproducts", "all-products", "products", "allproduct"];

      const aboutPromise = getPageContent({ page: "about", language }).catch(() => ({}));

      let productsData = {};
      for (const page of pageAliases) {
        try {
          const data = await getPageContent({ page, language });
          if (data && typeof data === "object" && Object.keys(data).length) {
            productsData = data;
            break;
          }
        } catch {
          // try next alias
        }
      }

      const aboutData = await aboutPromise;
      if (!isMounted) return;
      setPageContent(productsData);
      setAboutContent(aboutData && typeof aboutData === "object" ? aboutData : {});
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const heroSection =
    findPageSection(pageContent, "hero") ||
    findPageSection(pageContent, "allproductshero") ||
    findPageSection(pageContent, "allproducts");
  const exploreSection =
    findPageSection(pageContent, "explore") ||
    findPageSection(pageContent, "allproductsexplore") ||
    findPageSection(pageContent, "ourproducts") ||
    findPageSection(pageContent, "otherproducts");

  return (
    <div className="products-page">
      <div className="products-page-content-guide">
        <Navbar theme="dark" />
        <AllProductsHero content={unwrapSectionData(heroSection)} />
        <AllProductsExplore content={unwrapSectionData(exploreSection)} />
        <Hospitality />
        <AboutStartNewProject content={getAboutStartNewProjectContent(aboutContent)} />
      </div>
      <Footer />
    </div>
  );
};

export default AllProducts;
